export default __webpack_public_path__ + "static/media/e_shopping.d85eba10.png";